import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import ArrowBack from '@mui/icons-material/ArrowBack'; 

import Loading from '../components/common/Loading';
import Error from '../components/common/Error';
import SessionCustomersList from '../components/common/SessionCustomers/SessionCustomersList';

import { useSessionContext } from '../contexts/SessionContext';

export default function SessionCustomersPage( props ){
    //console.debug("RTS Break SessionCustomersPage");

    const {user, setSessionCustomer, prevSessionCustomer, userAuthToken, apiRoot, setAppMode, userLogOut} = useSessionContext();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [noData, setNoData] = useState(false);

    const [data, setData] = useState();

    const fetchData = useCallback((pUser) => {
        let apiURL = apiRoot + "/AppUsers/GetUserCustomerAccessList";
        axios
        .post(
            apiURL,
            pUser, 
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                if(response.data.length > 0){
                    setData(response.data);
                }
                else{
                    setNoData(true)
                    console.error("RTS Customers", "No User Customer Associations.");
                }
            }
            else{
                setNoData(true)
                console.error("RTS Customers", "No User Customer Associations.");
            }

            setIsLoading(false);
            setHasError(false);
        })
        .catch(error => {
            setIsLoading(false);
            setHasError(true);
            console.log("RTS Data Error", error);
        });
    },[apiRoot, userAuthToken.token]);
    

    useEffect(() => {
        fetchData(user);
    }, [user, fetchData]);


    // useEffect(() => {
    //     if(data !== null && data.length > 0){
    //         setIsLoading(false);
    //         setHasError(false);
    //     }
    //     else{
    //         setIsLoading(false);
    //         setHasError(false);
    //         setNoData(true)
    //         console.error("RTS Data Error", "No User Customer Associations.");                
    //     }
    // }, [data]);    
    

    const handleClick = (e) => {
        setSessionCustomer(prevSessionCustomer);
    } 
    

    const checkForNull = () => {
        let retValue;

        if(!prevSessionCustomer){
            retValue = false;
        }
        else{
            retValue = true;
        }
        return retValue;
    } 
    
    
    const setTableHeight = () => {
        let retValue;

        if(smallForm){
            retValue = 'auto';
        }
        else{
            if(!prevSessionCustomer){
                retValue = '85vh';
            }
            else{
                retValue = '80vh';
            }
        }
        return retValue;
    }    


    if(hasError){
        return(
            <Error />
        );
    }


    if(isLoading){
        return(
            <Loading />
        );
    }

    if(noData){
        return (
            <>
            <Box sx={{display:'flex', 
                      alignItems:'center', 
                      justifyContent:'center', 
                      flexDirection:'column', 
                      height:'100%', 
                      p:0, 
                      mt:3,
                      border:'1px solid grey', 
                      borderRadius:1}}>
                <Typography variant='h5' sx={{color:'red'}}>No Customers</Typography>
                <Typography variant="caption">The user has no customer access.  Please contact support to associate customers with this user.</Typography>                
            </Box>

            <Box>
                <Button startIcon={<ArrowBack />} 
                    variant="contained" 
                    onClick={() => {setAppMode(null);}} 
                    sx={{mt:2, mr:2}}
                >Back</Button>
            </Box>
            </>
        );        
    }


    return(
        <Box>
            <Box sx={{pt:2, height:setTableHeight(), minHeight:'500px'}}>
                <SessionCustomersList data={data} />
            </Box>
            <Box sx={{textAlign:'center', mt:3}}>
            {
                checkForNull()
                ?
                <Button variant="contained" onClick={handleClick}>Cancel</Button>
                :
                ""
            }
            </Box>
        </Box>        
    );
}
